// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt
// shopping cart
frappe.provide("erpnext.e_commerce.shopping_cart");
var shopping_cart = erpnext.e_commerce.shopping_cart;
const style = document.createElement('style');
style.innerHTML = `
.loader, .loader:before, .loader:after {
	border-radius: 50%;
	width: 2.5em;
	height: 2.5em;
	animation-fill-mode: both;
	animation: bblFadInOut 1.8s infinite ease-in-out;
}
.loader {
	color: #FFF;
	font-size: 7px;
	position: relative;
	text-indent: -9999em;
	transform: translateZ(0);
	animation-delay: -0.16s;
}
.loader:before,
.loader:after {
	content: '';
	position: absolute;
	top: 0;
}
.loader:before {
	left: -3.5em;
	animation-delay: -0.32s;
}
.loader:after {
	left: 3.5em;
}
@keyframes bblFadInOut {
	0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em }
	40% { box-shadow: 0 2.5em 0 0 }
}
`;
document.head.appendChild(style);

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};



function showLoader() {
	if (window.location.pathname === "/cart") 
		return;

	var loaderContainer = document.createElement('div');
	loaderContainer.style.position = 'fixed';
	loaderContainer.style.top = '0';
	loaderContainer.style.left = '0';
	loaderContainer.style.width = '100%';
	loaderContainer.style.height = '100%';
	loaderContainer.style.display = 'flex';
	loaderContainer.style.justifyContent = 'center';
	loaderContainer.style.alignItems = 'center';
	loaderContainer.style.zIndex = '9999';
	loaderContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';

	var button = document.createElement('button');
	button.className = 'd-flex align-items-center px-3';
	button.type = 'button';
	button.disabled = true;
	button.style.backgroundColor = '#373737';
	button.style.opacity = '60%';
	button.style.fontSize= '24px';
	button.style.color= 'white';
	button.style.flexDirection= 'row-reverse';




	var spinner = document.createElement('span');
	spinner.className = 'spinner-border spinner-border-sm ml-2'; // فاصله‌ی راست با متن
	spinner.setAttribute('role', 'status');
	spinner.setAttribute('aria-hidden', 'true');

	var text = document.createElement('span');
	text.innerText = ' ...درحال بروزرسانی سبد خرید';

	button.appendChild(spinner);
	button.appendChild(text);
	loaderContainer.appendChild(button);
	document.body.appendChild(loaderContainer);

	document.body.style.pointerEvents = 'none';
}

// Method to hide the loader and enable user interactions
function hideLoader() {
	if (window.location.pathname === "/cart") 
		return;
	// Remove the loader container from the body
	var loaderContainer = document.querySelector('div[style*="position: fixed"]');
	if (loaderContainer) {
		loaderContainer.remove();
	}

	// Enable user interactions
	document.body.style.pointerEvents = 'auto';
}

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();
});

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").on('shown.bs.dropdown', function() {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					method: 'erpnext.e_commerce.shopping_cart.cart.get_shopping_cart_menu',
					callback: function(r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	update_cart: function(opts) {

		showLoader();

		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('erpnext.e_commerce.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {
			shopping_cart.freeze();
			return frappe.call({
				type: "POST",
				method: "erpnext.e_commerce.shopping_cart.new_cart.add_item_cart",
				args: {
					item_code: opts.item_code,
					qty: opts.qty,
          additional_cost_items: opts.additional_cost_items,
					additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
					with_items: opts.with_items || 0,
					add:opts.add
				},
				btn: opts.btn,
				callback: function(r) {
					hideLoader();
					if (document.getElementById("g-total")) {
						document.getElementById("g-total").textContent=commafy(r.message['grand_total']/10);
						document.getElementById("n-total").textContent=commafy(r.message['net_total']/10);
						document.getElementById("x-total").textContent=commafy(r.message['items_total']/10);
						document.getElementById("d-total").textContent = commafy(r.message['total_discount'] / 10);
						if(document.getElementById(r.message['item_name'])){
							document.getElementById(r.message['item_name']).textContent=commafy(r.message['item_total']/10);
							const inputEl = document.querySelector(`input[data-item-code="${opts.item_code}"]`);

							// Change the value
							if (inputEl) {
								inputEl.value = r.message['item_qty']; // set to new value
							}
						}
						if(document.getElementById("total_items")){
							document.getElementById("total_items").textContent=commafy(r.message['total_qty']);
						}
						
						if(r.message['total_qty'] == 0){
							location.reload();
						}
					}

					

					if (r.message["error"]) {
						frappe.msgprint({
							title: __('Error'),
							indicator: 'red',
							message: r.message["error"]
						});
						
						// if(document.querySelector('.shippingcheck:checked')){
						// 	// show_cart_loader();
						// 	// var shipping_name = document.querySelector('.shippingcheck:checked').value;
						// 	// frappe.call({
						// 	// 	async:false,
						// 	// 	method: "erpnext.e_commerce.shopping_cart.cart.get_total_with_shipping",
						// 	// 	args:{shipping_name:shipping_name},
						// 	// 	callback: function(r) {
	
						// 	// 		document.getElementById("g-total").textContent=commafy(r.message[0]/10);
						// 	// 		document.getElementById("n-total").textContent=commafy(r.message[1]/10);
						// 	// 		// document.getElementById("n-total").textContent=commafy(r.message["net_total"]/10);
						// 	// 		// document.getElementById("total_items").textContent=commafy(r.message["qty"]);
						// 	// 		// document.getElementById("g-total").textContent=commafy(r.message["doc"].grand_total + parseInt(amount));
						// 	// 		// var rd = document.getElementById("g-total");
						// 	// 		// rd.checked = true;
						// 	// 		hide_cart_loader();
									
						// 	// 	}});
						// 	// show_cart_loader();
						// 	// frappe.call({
						// 	// 	async:false,
						// 	// 	method: "erpnext.e_commerce.shopping_cart.cart.get_net_total_with_shipping",
						// 	// 	args:{shipping_name:shipping_name},
						// 	// 	callback: function(r) {
	
						// 	// 		// document.getElementById("n-total").textContent=commafy(r.message/10);
						// 	// 		// document.getElementById("n-total").textContent=commafy(r.message["net_total"]/10);
						// 	// 		// document.getElementById("total_items").textContent=commafy(r.message["qty"]);
						// 	// 		// document.getElementById("g-total").textContent=commafy(r.message["doc"].grand_total + parseInt(amount));
						// 	// 		// var rd = document.getElementById("g-total");
						// 	// 		// rd.checked = true;
						// 	// 		hide_cart_loader();
									
						// 	// 	}});
						// 		show_cart_loader();
						// 		frappe.call({
						// 			method: "erpnext.e_commerce.shopping_cart.cart.get_shipping_rules_list",
						// 			callback: function(r) {
										
						
						// 				r.message.forEach(rule => {
						// 					// Generate the element ID based on the rule name
						// 					const elementId = `amount-${rule.name}`;
						// 					// Find the element by ID
						// 					const element = document.getElementById(elementId);
						// 					if (element) {
						// 						// Update the element's innerHTML with the new value
						// 						element.innerHTML = commafy(rule.amount / 10); // Adjust formatting if needed
						// 					}
						// 				});
						// 				hide_cart_loader();
						// 			}});
									
						// }else{
						// 	frappe.call({
						// 		async:false,
						// 		method: "erpnext.e_commerce.shopping_cart.cart.get_total_with_shipping",
						// 		args:{shipping_name:""},
						// 		callback: function(r) {
	
						// 			document.getElementById("g-total").textContent=commafy(r.message["grand_total"]);
						// 			document.getElementById("n-total").textContent=commafy(r.message["net_total"]);
						// 			document.getElementById("total_items").textContent=commafy(r.message["qty"]);
						// 			// document.getElementById("g-total").textContent=commafy(r.message["doc"].grand_total + parseInt(amount));
						// 			// var rd = document.getElementById("g-total");
						// 			// rd.checked = true;
						// 			frappe.call({
						// 				method: "erpnext.e_commerce.shopping_cart.cart.get_shipping_rules_list",
						// 				callback: function(r) {
											
							
						// 					r.message.forEach(rule => {
						// 						// Generate the element ID based on the rule name
						// 						const elementId = `amount-${rule.name}`;
						// 						// Find the element by ID
						// 						const element = document.getElementById(elementId);
						// 						if (element) {
													
						// 							commafy(rule.amount / 10)
						// 						}
						// 					});
											
						// 				}});
									
									
						// 		}});
						// 	}
	
						
					} 
					shopping_cart.unfreeze();
					shopping_cart.set_cart_count(true);
					if(opts.callback)
						opts.callback(r);
					hide_cart_loader();
				}
			});
			
		}

		
	},

	set_cart_count: function(animate=false) {

		$(".intermediate-empty-cart").remove();

		var cart_count = frappe.get_cookie("cart_count");

		if(frappe.session.user==="Guest") {
			cart_count = 0;
		}

		if(cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");
		//$badge.html(r.message.doc.total_qty);

		if((parseInt(cart_count) === 0 || cart_count == undefined) && frappe.session.user != "Guest") {
			// $cart.css("display", "none");
			// $(".cart-tax-items").hide();
			// $(".btn-place-order").hide();
			// $(".cart-payment-addresses").hide();

			// let intermediate_empty_cart_msg = `
			// 	<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
			// 		${ __("Cart is Empty") }
			// 	</div>
			// `;
			// $(".cart-table").after(intermediate_empty_cart_msg);

			
			
			// frappe.call({
			// 	method: 'erpnext.e_commerce.shopping_cart.cart.get_cart_quotation',
			// 	callback: function(r) {
			// 		$cart.css("display", "inline");
			// 		$badge.html(r.message.doc.total_qty);
			// 		// $badge.html(r.message.doc.total_qty)
			// 	}
			// });
			
			
			
		}
		else {

			$cart.css("display", "inline");
			// $("#cart-count").text(cart_count);
			$badge.html(cart_count);

			

		}
		

		if(cart_count) {
			$badge.html(cart_count);

			if (animate) {
				$cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
				}, 500);
			}
		}

		
	},

	shopping_cart_update: function({item_code, qty, cart_dropdown, additional_notes , add=false}) {
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			with_items: 1,
			add: add,
			btn: this,
			callback: function(r) {
				
				if (qty == 0){
					document.querySelector(`tr[data-name="${r.message['item_name']}"]`).remove();
					// show_cart_loader();
					// location.reload()
				}
				else
				{
					if(!r.exc) {
						$(".cart-items").html(r.message.items);
						$(".cart-tax-items").html(r.message.total);
						$(".payment-summary").html(r.message.taxes_and_totals);
						shopping_cart.set_cart_count();
						
						if (cart_dropdown != true) {
							$(".cart-icon").hide();
						}
					}
				}
				
			},
		});
	},

	show_cart_navbar: function () {
		// frappe.call({
		// 	method: "erpnext.e_commerce.doctype.e_commerce_settings.e_commerce_settings.is_cart_enabled",
		// 	callback: function(r) {
		// 		$(".shopping-cart").toggleClass('hidden', r.message ? false : true);
		// 	}
		// });
		$(".shopping-cart").toggleClass('hidden', false);
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);
			$btn.prop('disabled', true);

			if (frappe.session.user==="Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('erpnext.e_commerce.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			$btn.addClass('hidden');
			$btn.closest('.cart-action-container').addClass('d-flex');
			$btn.parent().find('.go-to-cart').removeClass('hidden');
			$btn.parent().find('.go-to-cart-grid').removeClass('hidden');
			$btn.parent().find('.cart-indicator').removeClass('hidden');

			const item_code = $btn.data('item-code');
			erpnext.e_commerce.shopping_cart.update_cart({
				item_code,
				qty: 1
			});

		});
	},

	freeze() {
		if (window.location.pathname !== "/cart") 
			return;
		show_cart_loader();
	},

	unfreeze() {
		if (window.location.pathname !== "/cart") 
			return;
		hide_cart_loader();
	}
});